var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('el-row',[_c('el-col',{attrs:{"xs":24,"sm":24,"md":24,"lg":24,"xl":24}},[_c('p',{staticClass:"font-16 mt30"},[_vm._v("COPYRIGHT ©2022 江苏精益智控科技有限公司 版权所有苏ICP备18036996号-1")]),_c('p',{staticClass:"font-16"},[_vm._v("技术支持 江苏精益智控科技有限公司")]),_c('p',{staticClass:"font-16"},[_vm._v("客服热线 0510-85108968")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }